import React, { useEffect } from 'react';
import { useToast, Box, Flex, Text, Icon, IconButton } from '@chakra-ui/react';
import { connect } from 'react-redux';
import { hideToast } from '../redux/actions/alertActions';
import { MdCheckCircle, MdError, MdWarning, MdInfo, MdClose } from 'react-icons/md';

const statusConfig = {
	success: {
		icon: MdCheckCircle,
		color: 'green.500',
		bg: 'white',
		border: 'green.400',
		title: 'Success',
	},
	error: {
		icon: MdError,
		color: 'red.500',
		bg: 'white',
		border: 'red.400',
		title: 'Error',
	},
	warning: {
		icon: MdWarning,
		color: 'orange.400',
		bg: 'white',
		border: 'orange.400',
		title: 'Warning',
	},
	info: {
		icon: MdInfo,
		color: 'blue.500',
		bg: 'white',
		border: 'blue.400',
		title: 'Info',
	},
};

const Alert = ({ toastMessage, toastStatus, isVisible, hideToast }) => {
	const toast = useToast();

	useEffect(() => {
		if (isVisible) {
			const config = statusConfig[toastStatus] || statusConfig.info;
			toast({
				duration: 4000,
				isClosable: true,
				position: 'top-right',
				render: ({ onClose }) => (
					<Box
						bg={config.bg}
						borderRadius="xl"
						boxShadow="0 4px 24px rgba(0,0,0,0.12)"
						border="1px solid"
						borderColor="gray.100"
						borderLeft="4px solid"
						borderLeftColor={config.border}
						px={4}
						py={3}
						minW="280px"
						maxW="360px"
					>
						<Flex align="flex-start" gap={3}>
							<Icon as={config.icon} color={config.color} boxSize={5} mt={0.5} flexShrink={0} />
							<Box flex={1} minW={0}>
								<Text fontWeight="semibold" fontSize="sm" color="gray.800" mb={0.5}>
									{config.title}
								</Text>
								<Text fontSize="sm" color="gray.600" lineHeight="short">
									{toastMessage}
								</Text>
							</Box>
							<IconButton
								aria-label="Close"
								icon={<MdClose />}
								size="xs"
								variant="ghost"
								color="gray.400"
								_hover={{ color: 'gray.600', bg: 'gray.100' }}
								borderRadius="md"
								onClick={onClose}
								flexShrink={0}
							/>
						</Flex>
					</Box>
				),
			});
			hideToast();
		}
	}, [isVisible, toastMessage, toastStatus, toast, hideToast]);

	return null;
};

const mapStateToProps = (state) => ({
	toastMessage: state.alert.message,
	toastStatus: state.alert.status,
	isVisible: state.alert.isVisible,
});

export default connect(mapStateToProps, { hideToast })(Alert);
